'use strict';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const $ = jQuery.noConflict();

$(function() {

	const benefits = {

		init: function() {
			this.cacheDOM();
			if (!this.$component.length) {
				return;
			}
			if (this.prefersReducedMotion()) {
				gsap.set(this.$items.toArray(), {opacity: 1, y: 0});
				return;
			}
			gsap.registerPlugin(ScrollTrigger);
			this.entranceAnimation();
		},

		cacheDOM: function() {
			this.$component = $('.js-benefits');
			this.$list = this.$component.find('.benefits__list');
			this.$items = this.$component.find('.js-benefits-item');
		},

		prefersReducedMotion: function() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

		entranceAnimation: function() {
			gsap.fromTo(
				this.$items.toArray(),
				{opacity: 0, y: 20},
				{
					opacity: 1,
					y: 0,
					duration: 0.55,
					stagger: 0.1,
					ease: 'power2.out',
					scrollTrigger: {
						trigger: this.$list[0],
						start: 'top 60%',
					},
					onComplete: () => {
						gsap.set(this.$items.toArray(), {clearProps: 'transform'});
					},
				}
			);
		},

	};

	benefits.init();
});
